import script from "./DesktopSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesktopSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./DesktopSidebar.vue?vue&type=style&index=0&id=1fce5d87&scoped=true&lang=css"
import "./DesktopSidebar.vue?vue&type=style&index=1&id=1fce5d87&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fce5d87"]])

export default __exports__